import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function Signup() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }
    setLoading(true);
    try {
      await register(email, password, name);
      toast.success("Welcome, e hine. Let's begin.");
      nav("/onboarding");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not create your account");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen whenua-gradient grain flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <Link to="/" className="font-serif text-xl text-ngahere mb-8 block" data-testid="back-home">
          ← Mā te mātau ki ora
        </Link>
        <div className="bg-muka rounded-3xl p-8 sm:p-10 border border-border shadow-[0_8px_30px_rgba(42,42,42,0.06)]">
          <h1 className="font-serif text-3xl text-charcoal mb-2">Tīmata · begin</h1>
          <p className="text-sm text-muted-foreground mb-8">
            This is yours. No data is shared. No reports. Just you and the kaupapa.
          </p>

          <form onSubmit={submit} className="space-y-5">
            <Field
              label="What name do you go by?"
              value={name}
              onChange={setName}
              testid="signup-name"
              required
              placeholder="e.g. Aroha"
            />
            <Field label="Email" type="email" value={email} onChange={setEmail} testid="signup-email" required />
            <Field
              label="Password (min 6)"
              type="password"
              value={password}
              onChange={setPassword}
              testid="signup-password"
              required
            />
            <button
              type="submit"
              disabled={loading}
              data-testid="signup-submit"
              className="w-full py-4 rounded-full bg-ngahere text-muka hover:bg-ngahere/90 transition-colors font-medium disabled:opacity-50"
            >
              {loading ? "..." : "Whakaara · create"}
            </button>
          </form>

          <div className="mt-6 text-sm text-center text-charcoal/70">
            Already walking?{" "}
            <Link to="/login" className="text-kokowai underline-offset-4 hover:underline" data-testid="link-login">
              Sign in
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

function Field({ label, type = "text", value, onChange, testid, required, placeholder }) {
  return (
    <label className="block">
      <span className="text-[11px] uppercase tracking-[0.18em] text-muted-foreground">{label}</span>
      <input
        type={type}
        required={required}
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        data-testid={testid}
        className="mt-2 w-full px-4 py-3.5 rounded-xl border border-border bg-bone focus:outline-none focus:ring-2 focus:ring-ngahere transition-all"
      />
    </label>
  );
}
